import { Component } from '@angular/core';
import {
	UntypedFormControl,
	Validators,
	FormsModule,
	ReactiveFormsModule,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { MatCard } from '@angular/material/card';
import { NgClass } from '@angular/common';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/list';
import { TOSAndPrivacyPolicyComponent } from '../../terms-of-use-and-privacy-policy/tos-and-privacy-policy.component';

@Component({
	selector: 'app-forgot-password',
	templateUrl: './forgot-password.component.html',
	styleUrls: [
		'./forgot-password.component.scss',
		'../common/modal.scss',
		'../common/main.scss',
	],
	imports: [
		MatCard,
		NgClass,
		MatFormField,
		MatLabel,
		MatInput,
		FormsModule,
		ReactiveFormsModule,
		MatError,
		MatButton,
		MatIcon,
		MatDivider,
		TOSAndPrivacyPolicyComponent,
	],
})
export class ForgotPasswordComponent {
	emailFormControl = new UntypedFormControl('', [
		Validators.required,
		Validators.email,
	]);
	showResetEmailSent = false;

	constructor(
		private authService: AuthService,
		private router: Router,
		private dialog: MatDialog
	) {}

	async sendPasswordResetEmail(): Promise<void> {
		if (this.emailFormControl.valid) {
			await this.authService
				.getPasswordResetToken(this.emailFormControl.value)
				.then((_) => {
					this.showResetEmailSent = true;
				});
		}
	}

	onBackClicked(): void {
		this.router.navigateByUrl('/login');
	}

	onConfirmClicked(): void {
		this.router.navigateByUrl('/login');
	}
}
